export function LogoMark({ size = 34 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <rect x="2" y="2" width="44" height="44" rx="12" fill="#0f1b18" stroke="#2DD4BF" strokeWidth="2.5" />
      <path d="M14 31 L24 15 L34 31" stroke="#2DD4BF" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M18.5 25.5 h11" stroke="#2DD4BF" strokeWidth="3" strokeLinecap="round" strokeDasharray="4 4" />
    </svg>
  );
}

export function Logo({ size = 34, sub = null }) {
  return (
    <div className="flex items-center gap-3" data-testid="logo">
      <LogoMark size={size} />
      <div className="leading-tight">
        <div className="font-bold tracking-tight text-foreground" style={{ fontSize: size * 0.5 }}>
          Cuero <span className="text-primary">&amp;</span> Co.
        </div>
        {sub && <div className="text-xs text-muted-foreground">{sub}</div>}
      </div>
    </div>
  );
}
